var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell-group',{attrs:{"title":"查询"}},[_c('van-cell',{attrs:{"title":"所有记录","is-link":"","size":"large","icon":"search","to":"/cap/lst"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }